<template>
  <div class="StepTwo">
     <el-form label-position="right" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="员工通过何种方式持股：">
                <el-select class="input" v-model="formType.holdingtype">
                  <el-option v-for="(item,index) in holdingtype" :label="item.name" :value="item.value" :key="index"></el-option>
                </el-select>

                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">
                      <p><strong>自然人持股：</strong>
                      即激励对象直接持有主体公司的股份,员工可在股东会行使表决权，并拥有法律法规赋予的其<br/>他股东权利。</p>
                      <p><strong>通过有限公司持股：</strong>
                      通过平台间接持有公司股权，并通过参与有限公司持股平台股东决策拥有公司表决权。</p>
                      <p><strong>通过有限合伙企业持股：</strong>
                      通过平台间接持有公司股权，员工不具备表决权。</p>
                    </div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
            <el-form-item label="是否办理工商变更：" v-if="formType.holdingtype == 1">
                <el-select class="input" v-model="formType.ischangereg">
                  <el-option v-for="(item,index) in ischangereg" :label="item.name" :value="item.value" :key="index"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="股权激励的股份来源：">
                <el-select class="input" v-model="formType.sharesource">
                  <el-option v-for="(item,index) in sharesource" :label="item.name" :value="item.value" :key="index"></el-option>
                </el-select>
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">
                      <p><strong>增资扩股：</strong>
                      公司总股本增加，原股东股份比例被稀释，激励对象购股资金进入公司账户。 </p>
                      <p><strong>单一股东转让：</strong>
                      该股东股份减少，激励对象的购股资金归转让方。 </p>
                      <p><strong>全体原股东等比例转让：</strong>
                      原股东股份比例减少，激励对象购股资金归全体原股东。</p>
                    </div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>

            </el-form-item>
        </el-form>
    <div class="animated fadeInUp btnlist">
        <el-button @click="next(0)" type="primary" plain>上一步</el-button>
        <el-button @click="next(2)" type="primary">下一步</el-button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'StepTwo',
  props: ['formType'],
  data () {
    return {
      holdingtype: [
        {name: "通过自然人持股", value: "1"},
        {name: "通过有限公司持股", value: "2"},
        {name: "通过有限合伙企业持股", value: "3"}
      ],
      ischangereg: [
        {name: "否", value: "0"},
        {name: "是", value: "1"}
      ],
      sharesource: [
        {name: "增资扩股 ", value: "1"},
        {name: "单一原股东转让", value: "2"},
        {name: "全体原股东等比例转让", value: "3"}
      ]
    }
  },
  mounted () {
    $('html').scrollTop(0)
  },
  methods: {
    next(type) {
      if (type == 2) {
          if (this.formType.holdingtype.length == 0) {
            this.$message.warning('请选择员工通过何种方式持股')
          } else if (this.formType.ischangereg.length == 0 && this.formType.holdingtype == 1) {
            this.$message.warning('请选择是否办理工商变更')
          } else if (this.formType.sharesource.length == 0) {
            this.$message.warning('请选择股权激励的股份来源')
          } else {
            this.$emit('setStepValue', 2)
          }
      } else {
          this.$emit('setStepValue', 0)
      }
    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepTwo {
  margin-top: 50px;
  background-color: #fff;
  .el-form {
    padding-left: 270px;
  }
  
}
.tooltip_content {
    p {
      width: 331px;
      strong {
        font-weight: bold;
      }
      &~p {
        margin-top: 20px;
      }

    }
  }
</style>